import { schema } from 'normalizr';
import { SCHEMA_TYPE_ORGS } from '../constants/schemaTypes';
import userSchema from './user';

const orgSchema = new schema.Entity(SCHEMA_TYPE_ORGS, {
  owner: userSchema,
  billing_owner: userSchema,
});

export default orgSchema;
